module.exports = __webpack_public_path__ + "static/media/cove.121e66e1.gif";